import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbc0bd54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  class: "mb-3 ml-2 mr-2",
  style: { 'font-size': 10}
}
const _hoisted_3 = { class: "mb-3 ml-2 mr-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 ml-2 mr-2" }, "Seeds: 10 $WATR / Day", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5 ml-2 mr-2" }, "2D Plants: 15 $WATR / Day", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5 ml-2 mr-2" }, "PLEASE UNSTAKE ALL NFTS AND MIGRATE THEM TO THE NEW SITE. SORRY FOR THE INCONVENIENCE.", -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button is-primary mb-5 ml-2 mr-2" }, " Return to the updated Farming Site ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("div", _hoisted_2, "NFTs Staked: " + _toDisplayString(_ctx.farmerAcc.gemsStaked), 1),
        _createElementVNode("div", null, " Staking Ends: " + _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.minStakingEndsTs)), 1),
        _createElementVNode("div", _hoisted_3, "Reward: " + _toDisplayString(Math.round((_ctx.farmerAcc.rewardA.accruedReward  - _ctx.farmerAcc.rewardA.paidOutReward) / 1000000)), 1),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("button", {
          class: "button is-primary mb-5 ml-2 mr-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
        }, " Refresh account ")
      ]),
      _hoisted_6,
      _createElementVNode("a", {
        href: 'https://www.growmetajuana.com/',
        target: "_blank"
      }, _hoisted_9, 8, _hoisted_7)
    ]),
    _hoisted_10
  ], 64))
}